// Customizable Area Start
import React, { useState, useEffect } from "react";
import Toolbar from "@material-ui/core/Toolbar";
import AppBar from "@material-ui/core/AppBar";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import Box from "@material-ui/core/Box";
import Badge from "@material-ui/core/Badge";
import NotificationsOutlinedIcon from "@material-ui/icons/NotificationsOutlined";
import KeyboardArrowDownOutlinedIcon from "@material-ui/icons/KeyboardArrowDownOutlined";
import MenuIcon from "@material-ui/icons/Menu";
import Divider from "@material-ui/core/Divider";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import {
  logoEverybrand,
  addIcon,
  ChatBubbleLargeIcon,
  StarIcon,
  UserIcon,
  EveryReelIcon,
} from "./assets";
import { NavigationMenuItem } from "./interfaces";
import { NavLink } from "react-router-dom";
import { AddRounded } from "@material-ui/icons";
import { WebsiteNormalized } from "./AppLayoutController.web";
import { Reactions } from "./Reactions.web";
import { Hidden } from "@material-ui/core";
import { getToken } from "../../../components/src/AuthService";
const baseURLConfig = require("../../../framework/src/config.js");

export const configJSON = require("./config.js");
const notificationsConfig = require("../../notifications/src/config.js");

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    appbar: {
      backgroundColor: theme.palette.background.paper,
      zIndex: theme.zIndex.drawer + 1,
      overflowX: "auto",
      transition: "all 0.3s ease-in-out", // Smooth animation for all properties
      [theme.breakpoints.down(950)]:{
        backgroundColor: "#f1f5f9",
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
      },
      [theme.breakpoints.down(650)]:{
        zIndex: 3,
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
      }
    },
    compact: {
      // Compact state - header is smaller
    },
    hidden: {
      transform: "translateY(-100%)",
      opacity: 0,
      pointerEvents: "none",
    },
    toolbar: {
      display: "flex",
      justifyContent: "space-between",
      paddingLeft: '6px',
      transition: "all 0.3s ease-in-out",
      minHeight: "64px",
      [theme.breakpoints.down(650)]: {
        minHeight: "64px",
      }
    },
    toolbarCompact: {
      minHeight: "48px",
      paddingLeft: '4px',
      [theme.breakpoints.down(650)]: {
        minHeight: "48px",
      }
    },
    button: {
      borderRadius: 0,
      fontWeight: 700,
      fontSize: "16px",
      fontStyle: "normal",
      fontFamily: "Inter",
      transition: `all 0.3s ${theme.transitions.easing.easeInOut} 0ms`,
      paddingLeft: 26
    },
    active: {
      "& .MuiButton-label": {
        borderBottom: `6px solid ${theme.palette.primary.main}`,
        marginTop: '6px',
      },
    },
    notificationButton: {
      "@media (max-width: 1149px)": {
        display: "none",
        "& button": {
          display: "none"
        }
      },
    },
    activeIcon: {
      borderWidth: "20px",
      borderBottom: `6px solid ${theme.palette.primary.main}`,
    },
    navigationContainer: {
      "@media (max-width: 1149px)": {
        display: "none",
      },
      "& :not(:last-child)": {
        marginRight: "10px",
      },
    },
    websiteListContainer: {
      display: "flex",
      alignItems: "center",
      "& > button:first-child": {
        minWidth: "auto"
      },
      "& hr": {
        backgroundColor: "#64748B",
        margin: theme.spacing(0, 2),
      },
    },
    quickAccessBtn: {
      width: theme.spacing(3),
      height: theme.spacing(3),
      borderRadius: theme.spacing(1),
      minWidth: 0,
      backgroundColor: theme.palette.primary.main,
      "&:hover": {
        backgroundColor: theme.palette.primary.main,
      },
    },
    menuButton: {
      [theme.breakpoints.up("lg")]: {
        display: "none",
      },
    },
    brandName: {
      "@media (max-width: 1150px)": {
        flex: 1
      },
      transition: "all 0.3s ease-in-out",
      "& img": {
        transition: "all 0.3s ease-in-out",
        height: "auto",
        maxHeight: "40px",
      }
    },
    brandNameCompact: {
      "& img": {
        maxHeight: "28px",
      }
    },
    icon: {
      color: "#000000",
    },
    badge: {
      position: "relative",
      "& .MuiBadge-badge": {
        backgroundColor: "#FF0000",
        color: "#FFFFFF",
        fontSize: "10px",
        fontWeight: 700,
        minWidth: "18px",
        height: "18px",
        padding: "0 4px",
        borderRadius: "9px",
        top: "4px",
        right: "4px",
        border: "2px solid #FFFFFF",
        boxSizing: "border-box",
      },
    },

    quickAccessMenu: {
      display: "flex",
      flexDirection: "column",
      width: "248px",
      gap: "5px",
      borderRadius: "8px",

      "& .MuiMenuItem-root": {
        whiteSpace: "unset",
      },

      "& > .MuiMenu-paper": {
        minWidth: "248px",
        borderRadius: "12px",
        padding: "4px",
        "& ul": {
          padding: 0
        }
      },
    },

    menuItem: {
      display: "flex",
      height: "75px",
      width: "100%",
      padding: "5px 15px",
      borderRadius: "8px",
      "&:hover": {
        backgroundColor: "#000",
        "& p, svg": {
          color: "#fff"
        },
        "& img": {
          filter: "invert(99%) sepia(32%) saturate(0%) hue-rotate(266deg) brightness(111%) contrast(100%)"
        }
      }
    },

    menuLink: {
      display: "flex",
      flexWrap: "nowrap",
      flexGrow: 1,
      alignItems: "center",
      gap: "10px",
      color: "#000",
      textDecoration: "none",
    },

    menuIconContainer: {
      display: "flex",
      alignItems: "center",
      width: "24px",
      height: "24px",
      minWidth: "24px",
      "& img": {
        objectFit: "cover"
      },
      "& #every_reel": {
        height: "20px",
        width: "20px"
      },
      "& #chat, #star": {
        height: "21px",
        width: "21px"
      },
      "& #user": {
        height: "19px",
        width: "19px"
      },
    },

    menuItemContent: {
      display: "flex",
      flexDirection: "column",
    },

    menuTitle: {
      fontSize: "15px",
      fontFamily: "Inter, 'sans-serif'",
      fontWeight: 700,
    },

    menuDescription: {
      fontSize: "11px",
      fontFamily: "Inter, 'sans-serif'",
      fontWeight: 400,
      lineHeight: "22px"
    },

    websitesMenu: {
      width: "164px",
      borderRadius: "5px",
    },

    websitesMenuItem: {
      borderRadius: "5px",

      "& a": {
        fontFamily: "Inter",
        color: "#000",
        textDecoration: "none",
        textTransform: "capitalize",
      },
      "&:hover": {
        backgroundColor: "#000",
        color:"white",
        "& p, svg": {
          color: "#fff"
        }
      }
    }
  })
);

interface Props {
  navigationMenus: NavigationMenuItem[];
  selectedWebsite?: WebsiteNormalized;
  websitesList: WebsiteNormalized[];
  onWebsiteSelect: (selectedWebsite: WebsiteNormalized) => void;
  currentUserInfo?:any
  onDrawerToggle: () => void;
}

const ITEM_HEIGHT = 48;

function NavigationMenu({
  navigationMenus,
  websitesList,
  selectedWebsite,
  onWebsiteSelect,
  onDrawerToggle,
  currentUserInfo
}: Props) {
  const [
    websiteSelectionAnchorEl,
    setWebsiteSelectionAnchorEl,
  ] = React.useState<null | HTMLElement>(null);
 
  const [
    quickAccessAnchorEl,
    setQuickAccessAnchorEl,
  ] = React.useState<null | HTMLElement>(null);


  const [isActive, setIsActive] = React.useState(false);
  const [isCompact, setIsCompact] = useState(false);
  const [isHidden, setIsHidden] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [unreadCount, setUnreadCount] = useState(0);

  const [currentWebsite, setCurrentWebsite] = React.useState<string>("");

  const handleToggleActive = () => {
    setIsActive(!isActive);
  };
  const classes = useStyles();

  const fetchUnreadNotificationCount = React.useCallback(async () => {
    try {
      const baseURL = baseURLConfig.baseURL || window.location.origin;
      const endpoint = notificationsConfig.notificationEndPoint.startsWith('/') 
        ? notificationsConfig.notificationEndPoint 
        : `/${notificationsConfig.notificationEndPoint}`;
      const fullURL = `${baseURL}${endpoint}`;
      
      const response = await fetch(fullURL, {
        method: notificationsConfig.getDataMethod,
        headers: {
          "Content-Type": notificationsConfig.apiContentType,
          token: getToken() || "",
        },
      });
      
      if (response.ok) {
        const responseJson = await response.json();
        if (responseJson?.data) {
          const unreadNotifications = responseJson.data.filter(
            (notification: any) => !notification.attributes?.is_read
          );
          const count = unreadNotifications.length;
          setUnreadCount(count);
        } else {
          console.log("No notification data in response");
        }
      } else {
        console.error("Failed to fetch notifications:", response.status, response.statusText);
      }
    } catch (error) {
      console.error("Error fetching unread notification count:", error);
    }
  }, []);

  const markAllNotificationsAsRead = React.useCallback(async () => {
    try {
      const baseURL = baseURLConfig.baseURL || window.location.origin;
      const endpoint = notificationsConfig.markasReadEndpoint.startsWith('/') 
        ? notificationsConfig.markasReadEndpoint 
        : `/${notificationsConfig.markasReadEndpoint}`;
      const fullURL = `${baseURL}${endpoint}`;
      
      const response = await fetch(fullURL, {
        method: notificationsConfig.markAsReadMethod,
        headers: {
          "Content-Type": notificationsConfig.apiContentType,
          token: getToken() || "",
        },
      });
      
      if (response.ok) {
        // Mark all as read succeeded, refresh the count
        setUnreadCount(0);
        // Also refresh from server to ensure consistency
        setTimeout(() => {
          fetchUnreadNotificationCount();
        }, 500);
      } else {
        console.error("Failed to mark all notifications as read:", response.status, response.statusText);
      }
    } catch (error) {
      console.error("Error marking all notifications as read:", error);
    }
  }, [fetchUnreadNotificationCount]);

  // Fetch unread notification count
  useEffect(() => {
    fetchUnreadNotificationCount();
    // Refresh count every 30 seconds
    const interval = setInterval(() => {
      fetchUnreadNotificationCount();
    }, 30000);
    
    return () => clearInterval(interval);
  }, [fetchUnreadNotificationCount]);

  // Expose a global helper to force-expand the header (used when jumping to top)
  useEffect(() => {
    if (typeof window !== 'undefined') {
      (window as any).showDashboardHeader = () => {
        setIsCompact(false);
        setIsHidden(false);
        setLastScrollY(0);
      };
      // Expose function to refresh notification count
      (window as any).refreshNotificationCount = fetchUnreadNotificationCount;
    }
  }, []);

  // Mobile scroll behavior - shrink header when scrolling down, expand when scrolling up
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      
      // Only apply on mobile devices (screen width <= 650px)
      if (window.innerWidth <= 950) {
        // Shrink header when scrolling down, expand when scrolling up
        if (currentScrollY > lastScrollY && currentScrollY > 50) {
          // Scrolling down and past threshold - compact + hide
          setIsCompact(true);
          setIsHidden(true);
        } else if (currentScrollY < lastScrollY) {
          // Scrolling up - reveal and expand
          setIsHidden(false);
          setIsCompact(false);
        } else if (currentScrollY <= 10) {
          // At top - always visible
          setIsHidden(false);
          setIsCompact(false);
        }
      } else {
        // Always expanded and visible on desktop
        setIsHidden(false);
        setIsCompact(false);
      }
      
      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [lastScrollY]);


  const businessWebsites = currentUserInfo?.attributes?.business_website || '';
  const businessWebsiteList = businessWebsites.split(',');

 
  const displayWebsite = businessWebsiteList.length === 1
    ? businessWebsiteList[0]
    : currentWebsite || businessWebsiteList[0];

  const handleWebsiteMenuItemClick = (websiteName: string) => {
    
    setCurrentWebsite(websiteName);
    setWebsiteSelectionAnchorEl(null);
   
  };


  return (
    <AppBar className={`${classes.appbar} ${isCompact ? classes.compact : ''} ${isHidden ? classes.hidden : ''}`} elevation={0}>
      <Toolbar className={`${classes.toolbar} ${isCompact ? classes.toolbarCompact : ''}`}>
        <Typography variant="h6" className={`${classes.brandName} ${isCompact ? classes.brandNameCompact : ''}`}>
          <img src={logoEverybrand} alt="Everybrand logo" />
        </Typography>
        <div className={classes.navigationContainer}>
          {navigationMenus && navigationMenus.length > 0
            ? navigationMenus.map((menu) => (
                <NavLink
                  key={menu.name}
                  to={menu.path}
                  activeClassName={classes.active}
                >
                  <Button
                    startIcon={<img src={menu.icon} />}
                    className={classes.button}
                    onClick={(event) => {
                      // If already on Home/Dashboard, scroll to top instead of reloading
                      const currentPath = window.location.pathname.toLowerCase();
                      const targetPath = String(menu.path || '').toLowerCase();
                      const isHomeLabel = menu.name && String(menu.name).toLowerCase() === 'home';
                      if (currentPath === targetPath || (isHomeLabel && currentPath.includes('dashboard'))) {
                        // Prevent default navigation behavior
                        event.preventDefault();
                        
                        // Ensure header is visible for proper top view
                        if (typeof window !== 'undefined' && (window as any).showDashboardHeader) {
                          (window as any).showDashboardHeader();
                        }

                        // Use the specialized function for handling home clicks from reels
                        if (typeof window !== 'undefined' && (window as any).handleHomeFromReels) {
                          (window as any).handleHomeFromReels();
                        } else {
                          // Fallback to existing functions
                          if (typeof window !== 'undefined' && (window as any).forceScrollToTop) {
                            (window as any).forceScrollToTop();
                          }
                          
                          if (typeof window !== 'undefined' && (window as any).resetToHomeView) {
                            (window as any).resetToHomeView();
                          }
                        }
                        
                        // Additional scroll to top for any remaining scrollable elements
                        setTimeout(() => {
                          // Scroll main window to top
                          window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
                          
                          // Find and scroll any reels container to top
                          const reelsContainer = document.querySelector('[class*="allPosts"]') || 
                                               document.querySelector('[class*="scroll"]');
                          if (reelsContainer) {
                            reelsContainer.scrollTo({ top: 0, behavior: 'smooth' });
                          }
                          
                          // Ensure Create New Post section is visible
                          const createPostInput = document.querySelector('input[placeholder="Create New Post"]') ||
                                                 document.querySelector('[data-test-id="create-post-field"]');
                          if (createPostInput) {
                            createPostInput.scrollIntoView({ 
                              behavior: 'smooth',
                              block: 'start'
                            });
                          }
                        }, 100);
                      }
                    }}
                  >
                    {menu.name}
                  </Button>
                </NavLink>
              ))
            : null}
        </div>
        <Hidden mdUp>
          <Reactions />
        </Hidden>
        <Hidden mdDown>
        <div className={classes.websiteListContainer}>
          <Button
            aria-controls="quick-access-menu"
            aria-haspopup="true"
            onClick={(event) => setQuickAccessAnchorEl(event.currentTarget)}
          >
            <img src={addIcon} alt="addIcon" />
          </Button>
          <Menu
            id="quick-access-menu"
            anchorEl={quickAccessAnchorEl}
            getContentAnchorEl={null}
            keepMounted
            open={Boolean(quickAccessAnchorEl)}
            onClose={() => setQuickAccessAnchorEl(null)}
            className={classes.quickAccessMenu}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
          >
            <MenuItem
              data-test-id="newPostMenuItem"
              className={classes.menuItem}
              onClick={() => {
                setQuickAccessAnchorEl(null);
              }}
            >
              <NavLink className={classes.menuLink} to="/NewPost">
                <Box
                  className={classes.menuIconContainer}
                  style={{ width: "10px", height: "10px" }}
                >
                  <AddRounded />
                </Box>
                <Box className={classes.menuItemContent}>
                  <Typography className={classes.menuTitle}>Post</Typography>
                  <Typography className={classes.menuDescription}>
                    {configJSON.menuPostsDescription}
                  </Typography>
                </Box>
              </NavLink>
            </MenuItem>

            <MenuItem
              data-test-id="newEveryreelMenuItem"
              className={classes.menuItem}
              onClick={() => {
                setQuickAccessAnchorEl(null);
              }}
            >
              <NavLink className={classes.menuLink} to="/CreateEveryreel">
                <Box className={classes.menuIconContainer}>
                  <img id="every_reel" src={EveryReelIcon} alt="menu icon" />
                </Box>
                <Box className={classes.menuItemContent}>
                  <Typography className={classes.menuTitle}>
                    Brandly
                  </Typography>
                  <Typography className={classes.menuDescription}>
                    {configJSON.menuEveryreelDescription}
                  </Typography>
                </Box>
              </NavLink>
            </MenuItem>

            <MenuItem
              data-test-id="newMessageMenuItem"
              className={classes.menuItem}
              onClick={() => {
                setQuickAccessAnchorEl(null);
              }}
            >
              <NavLink className={classes.menuLink} to="/messages?new-chat=true">
                <Box className={classes.menuIconContainer}>
                  <img id="chat" src={ChatBubbleLargeIcon} alt="menu icon" />
                </Box>
                <Box className={classes.menuItemContent}>
                  <Typography className={classes.menuTitle}>Message</Typography>
                  <Typography className={classes.menuDescription}>
                    {configJSON.menuMessageDescription}
                  </Typography>
                </Box>
              </NavLink>
            </MenuItem>

            <MenuItem
              data-test-id="newContactMenuItem"
              className={classes.menuItem}
              onClick={() => setQuickAccessAnchorEl(null)}
            >
              <NavLink className={classes.menuLink} to="/contacts/add">
                <Box className={classes.menuIconContainer}>
                  <img id="user" src={UserIcon} alt="menu icon" />
                </Box>
                <Box className={classes.menuItemContent}>
                  <Typography className={classes.menuTitle}>Contact</Typography>
                  <Typography className={classes.menuDescription}>
                    {configJSON.menuContactDescription}
                  </Typography>
                </Box>
              </NavLink>
            </MenuItem>

            <MenuItem
              data-test-id="newReviewMenuItem"
              className={classes.menuItem}
              onClick={() => setQuickAccessAnchorEl(null)}
            >
              <NavLink className={classes.menuLink} to="/ReviewInvite">
                <Box className={classes.menuIconContainer}>
                  <img id="star" src={StarIcon} alt="menu icon" />
                </Box>
                <Box className={classes.menuItemContent}>
                  <Typography className={classes.menuTitle}>Review</Typography>
                  <Typography className={classes.menuDescription}>
                    {configJSON.menuReviewDescription}
                  </Typography>
                </Box>
              </NavLink>
            </MenuItem>
          </Menu>
          <Divider orientation="vertical" flexItem />
      
            <div>
     
      {businessWebsiteList.length === 1 ? (
        <Button className={classes.button}>
          {displayWebsite}
        </Button>
      ) : (
        <div>
          <Button
            aria-controls="website-selection-menu"
            aria-haspopup="true"
            onClick={(event) => setWebsiteSelectionAnchorEl(event.currentTarget)} 
            startIcon={<KeyboardArrowDownOutlinedIcon />}
            className={classes.button}
            data-test-id="website-selection-button"
          >
            {displayWebsite} 
          </Button>

          <Menu
            id="website-selection-menu"
            anchorEl={websiteSelectionAnchorEl}
            getContentAnchorEl={null}
            keepMounted
            open={Boolean(websiteSelectionAnchorEl)} 
            onClose={() => setWebsiteSelectionAnchorEl(null)} 
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
            PaperProps={{
              style: {
                maxHeight: ITEM_HEIGHT * 4.5,
                maxWidth: '90vw'
              },
            }}
            className={classes.websitesMenu}
          >
            {businessWebsiteList && businessWebsiteList.length > 0
              ? businessWebsiteList.map((websiteName: string, i: number) => (
                  <MenuItem
                  data-test-id="menuItems"
                    key={i}  
                    onClick={() => handleWebsiteMenuItemClick(websiteName)}  
                    selected={websiteName === currentWebsite} 
                    className={classes.websitesMenuItem}
                  >
                    {websiteName}  {/* Display the website name */}
                  </MenuItem>
                ))
              : null}
          </Menu>
        </div>
      )}
    </div>
        </div>
        </Hidden>
        <IconButton
          color="inherit"
          edge="start"
          aria-label="open drawer"
          className={classes.menuButton}
          onClick={onDrawerToggle}
        >
          <MenuIcon />
        </IconButton>

        <NavLink
          to="/Notifications"
          style={{ textDecoration: "none" }}
          className={classes.notificationButton}
          activeClassName={classes.activeIcon}
          onClick={() => {
            // Mark all notifications as read when clicking the notification icon
            markAllNotificationsAsRead();
          }}
        >
          <IconButton
            aria-label="notifications"
            className={classes.icon}
            style={{ padding: "5px 2px" }}
            onClick={handleToggleActive}
          >
            <Badge 
              badgeContent={unreadCount > 0 ? unreadCount : 0} 
              className={classes.badge}
              max={99}
              showZero={false}
            >
              <NotificationsOutlinedIcon />
            </Badge>
          </IconButton>
        </NavLink>
      </Toolbar>
    </AppBar>
  );
}

export default NavigationMenu;
// Customizable Area End
